import deDeCore from "@devsalsa/vue-core/dist/locales/de-DE.json";
import enAuCore from "@devsalsa/vue-core/dist/locales/en-AU.json";
import enCaCore from "@devsalsa/vue-core/dist/locales/en-CA.json";
import enGbCore from "@devsalsa/vue-core/dist/locales/en-GB.json";
import enUsCore from "@devsalsa/vue-core/dist/locales/en-US.json";

import type { IntlDateTimeFormats, IntlNumberFormats } from "vue-i18n";

import { MarketplaceCode } from "@/shared/enums/MarketplaceCodeEnum";

import deDe from "@/locales/de-DE.json";
import enAu from "@/locales/en-AU.json";
import enCa from "@/locales/en-CA.json";
import enGb from "@/locales/en-GB.json";
import enUs from "@/locales/en-US.json";

export type Locale = "en-US" | "en-GB" | "en-CA" | "en-AU" | "en-DE" | "de-DE";

export const isMarketplace = (marketplace: MarketplaceCode) =>
  `${marketplace}.${import.meta.env.VITE_APP_DOMAIN}` === window.location.host;

export const getMarketplaceLocale = (): Locale => {
  if (isMarketplace(MarketplaceCode.Uk)) {
    return "en-GB";
  }
  if (isMarketplace(MarketplaceCode.Ca)) {
    return "en-CA";
  }
  if (isMarketplace(MarketplaceCode.Au)) {
    return "en-AU";
  }
  if (isMarketplace(MarketplaceCode.De)) {
    return "en-DE";
  }
  return "en-US";
};

export const marketplaceMessages = {
  "en-US": { ...enUs, ...enUsCore },
  "en-GB": { ...enGb, ...enGbCore },
  "en-CA": { ...enCa, ...enCaCore },
  "en-AU": { ...enAu, ...enAuCore },
  "en-DE": { ...enUs, ...enUsCore },
  "de-DE": { ...deDe, ...deDeCore },
};

export const marketplaceDateTimeFormats: IntlDateTimeFormats = {
  "en-US": {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    numeric: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    numericZeros: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
    time: {
      hour: "numeric",
      minute: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
    monthWithDay: {
      month: "long",
      day: "numeric",
    },
    monthDayYear: {
      month: "long",
      day: "numeric",
      year: "numeric",
    },
    monthYear: {
      month: "long",
      year: "numeric",
    },
    fullDateTime: {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    },
  },
  "en-GB": {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    numeric: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    numericZeros: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
    time: {
      hour: "numeric",
      minute: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
    monthWithDay: {
      month: "long",
      day: "numeric",
    },
    monthDayYear: {
      month: "long",
      day: "numeric",
      year: "numeric",
    },
    monthYear: {
      month: "long",
      year: "numeric",
    },
    fullDateTime: {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    },
  },
  "en-CA": {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    numeric: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    numericZeros: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
    time: {
      hour: "numeric",
      minute: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
    monthWithDay: {
      month: "long",
      day: "numeric",
    },
    monthDayYear: {
      month: "long",
      day: "numeric",
      year: "numeric",
    },
    monthYear: {
      month: "long",
      year: "numeric",
    },
    fullDateTime: {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    },
  },
  "en-AU": {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    numeric: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    numericZeros: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
    time: {
      hour: "numeric",
      minute: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
    monthWithDay: {
      month: "long",
      day: "numeric",
    },
    monthDayYear: {
      month: "long",
      day: "numeric",
      year: "numeric",
    },
    monthYear: {
      month: "long",
      year: "numeric",
    },
    fullDateTime: {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    },
  },
  "en-DE": {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    numeric: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    numericZeros: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
    time: {
      hour: "numeric",
      minute: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
    monthWithDay: {
      month: "long",
      day: "numeric",
    },
    monthDayYear: {
      month: "long",
      day: "numeric",
      year: "numeric",
    },
    monthYear: {
      month: "long",
      year: "numeric",
    },
    fullDateTime: {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    },
  },
  "de-DE": {
    short: {
      year: "numeric",
      month: "short",
      day: "numeric",
    },
    numeric: {
      year: "numeric",
      month: "numeric",
      day: "numeric",
    },
    numericZeros: {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    },
    time: {
      hour: "numeric",
      minute: "numeric",
    },
    long: {
      year: "numeric",
      month: "long",
      day: "numeric",
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
    },
    monthWithDay: {
      month: "long",
      day: "numeric",
    },
    monthDayYear: {
      month: "long",
      day: "numeric",
      year: "numeric",
    },
    monthYear: {
      month: "long",
      year: "numeric",
    },
    fullDateTime: {
      month: "long",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    },
  },
};

export const marketplaceNumberFormats: IntlNumberFormats = {
  "en-US": {
    currency: {
      style: "currency",
      currency: "USD",
      currencyDisplay: "symbol",
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: "percent",
      useGrouping: false,
    },
  },
  "en-GB": {
    currency: {
      style: "currency",
      currency: "GBP",
      currencyDisplay: "symbol",
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: "percent",
      useGrouping: false,
    },
  },
  "en-CA": {
    currency: {
      style: "currency",
      currency: "CAD",
      currencyDisplay: "symbol",
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: "percent",
      useGrouping: false,
    },
  },
  "en-AU": {
    currency: {
      style: "currency",
      currency: "AUD",
      currencyDisplay: "symbol",
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: "percent",
      useGrouping: false,
    },
  },
  "en-DE": {
    currency: {
      style: "currency",
      currency: "EUR",
      currencyDisplay: "symbol",
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: "percent",
      useGrouping: false,
    },
  },
  "de-DE": {
    currency: {
      style: "currency",
      currency: "EUR",
      currencyDisplay: "symbol",
    },
    decimal: {
      style: "decimal",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    },
    percent: {
      style: "percent",
      useGrouping: false,
    },
  },
};
